import useGetColors from "../../utils/colors";
import t from "../../theme";
import mmBgGreen from "../../assets/images/mm_bg_green.jpg";

export const useGetHomeScreenStyles = () => {
  const { themeColors } = useGetColors();
  return {
    pageContainer: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      "& .scrollingCarousal": {
        // marginTop: 16,
        "& > div": {
          borderRadius: 10,
          padding: 10,
          justifyContent: "var(--cj, center)",
          // background: 'aliceblue',
        },
        "& [data-arrow='left'], & [data-arrow='right']": {
          position: "absolute",
          left: "0",
          height: "50px",
          width: "50px",
          backgroundColor: "rgb(0 0 0 / 57%)",
          backdropFilter: "blur(6px)",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundImage:
            "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTYuNjcgMGwyLjgzIDIuODI5LTkuMzM5IDkuMTc1IDkuMzM5IDkuMTY3LTIuODMgMi44MjktMTIuMTctMTEuOTk2eiIgc3R5bGU9IgogICAgZmlsbDogd2hpdGU7CiI+PC9wYXRoPjwvc3ZnPg==)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          "& button": {
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
            border: 0,
            cursor: "pointer",
          },
          zIndex: 9,
        },
        "& [data-arrow='right']": {
          left: "unset",
          right: 0,
          transform: "rotate(180deg)",
          top: "32%",
          zIndex: 9,
        },
        "& div:last-child": {
          // gap: 12,
          // padding: '15px',
          // borderBottom: 'solid 1px #ddd',
          // boxShadow: '0 1px 8px #ddd'
        },
      },
    },
    scrollContainer11: {
      overflowY: "auto",
      height: "calc(100% - 80px)", // Adjust height as needed
      paddingTop: "8px",
    },
    flex: {
      display: "flex",
      flex: 1,
    },
    sideDrawer: {
      flexShrink: 0,
    },
    offerImg: {
      width: "16%",
      height: 120,
      // border: 'solid 1px #ddd',
      borderRadius: "10px",
      boxShadow: "0 0px 3px #aaa",
    },
    imageView: {
      justifyContent: "flex-start",
      alignItems: "center",
      height: "100%",
      display: "flex",
      overflow: "hidden",
      maxHeight: "80px",
      flexDirection: "column",
      width: "100%",
      "& img": {
        height: "80px",
        width: "auto",
        padding: "2px 2px 0 2px",
        objectFit: "contain",
        maxWidth: 110,
        // borderBottom: '5px solid #ddd',
      },
    },
    storeInfo: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      width: "100%",
      gap: "6px",
    },
    mobileNum: {
      display: "flex",
      alignItems: "center",
      gap: "2px",
      // background: "#fff",
      padding: "0px 8px",
      borderRadius: "12px",
      // boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    },
    mobileIcon: {
      fontSize: "0.85rem",
      color: "#333",
    },
    mobileText: {
      fontSize: "0.60rem",
      color: t.text.primary,
      fontWeight: 500,
    },
    mailBg: {
      fontSize: "3rem",
      color: "rgba(0, 0, 0, 0.54)",
      opacity: 0.3,
      marginTop: "-10px",
    },

    brandCard: {
      position: "relative",
      width: "165px",
      borderRadius: "14px",
      overflow: "hidden",
      background: "#fff",
      border: "1px solid rgba(0,0,0,0.09)",
      boxShadow: "0 3px 14px rgba(0,0,0,0.1), 0 1px 3px rgba(0,0,0,0.06)",
      transition: "box-shadow 0.18s ease",
      cursor: "pointer",
      flexShrink: 0,
      "&:hover": {
        boxShadow: "0 8px 28px rgba(0,0,0,0.18)",
      },
    },
    storeHeader: {
      background: [
        "repeating-linear-gradient(-45deg, transparent, transparent 8px, rgba(255,255,255,0.07) 8px, rgba(255,255,255,0.07) 16px),",
        "#2e7d32",
      ].join(""),
      padding: "16px 12px 58px",
      cursor: "pointer",
      position: "relative",
    },
    storeHeaderName: {
      display: "block",
      fontSize: "0.78rem",
      fontWeight: "800",
      color: "#fff",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textShadow: "0 1px 4px rgba(0,0,0,0.3)",
      letterSpacing: "0.02em",
    },
    storeRoofTrim: { display: "none" },
    storeSignBoard: { display: "none" },
    storeAwning: { display: "none" },
    storeSign: { display: "none" },
    storeImageArea: {
      position: "relative",
      margin: "0 auto",
      marginTop: "-62px",
      width: "124px",
      height: "124px",
      borderRadius: "50%",
      overflow: "hidden",
      border: "3px solid #fff",
      boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
      background: "#f1f8f0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2,
    },
    storeImg: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
      borderRadius: "50%",
    },
    storeCardBody: {
      padding: "8px 10px 12px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "4px",
    },
    storeCardBodyName: {
      fontSize: "0.82rem",
      fontWeight: "800",
      color: "#1a1a1a",
      textAlign: "center",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%",
    },
    storeCardName: {
      fontSize: "0.78rem",
      fontWeight: "700",
      color: t.text.primary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    storeCardActions: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
      justifyContent: "center",
      marginTop: "4px",
    },
    storeCardMeta: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      fontSize: "0.62rem",
      color: t.text.muted,
      "& span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
    storeMailBadge: {
      position: "absolute",
      top: "-8px",
      right: "-8px",
      background: "linear-gradient(135deg, #ffe066, #ffd54f, #ffb300)",
      color: "#8a5700",
      height: "20px",
      minWidth: "20px",
      padding: "0 4px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 1px 6px rgba(255,179,0,0.55), 0 0 0 2px #fff",
      zIndex: 10,
      cursor: "pointer",
      border: "none",
      outline: "none",
      fontSize: "0.65rem",
      fontWeight: "900",
      lineHeight: 1,
    },
    storeFavBtn: {
      position: "absolute",
      top: "4px",
      left: "4px",
      zIndex: 3,
      padding: "4px !important",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.15) !important",
      },
    },

    // glass: {
    //   position: "relative",               // ✅ required
    //   overflow: "hidden",                 // ✅ required

    //   background: "rgba(255, 255, 255, 0.15)",
    //   backdropFilter: "blur(20px)",
    //   WebkitBackdropFilter: "blur(20px)",

    //   borderRadius: 18,
    //   border: "1px solid rgba(255, 255, 255, 0.25)",

    //   boxShadow:
    //     "0 8px 32px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.4)",

    //   "&::before": {
    //     content: '""',                     // ✅ must be string
    //     position: "absolute",
    //     inset: 0,
    //     borderRadius: "inherit",

    //     background:
    //       "linear-gradient(120deg, rgba(255,255,255,0.35), rgba(255,255,255,0.05), transparent)",

    //     pointerEvents: "none",
    //     zIndex: 1,
    //   },
    // },

    brandCardsWrapper: {
      display: "flex",
      flexWrap: "wrap",
      margin: "15px auto",
      maxWidth: "98%",
      justifyContent: "flex-start",
      gap: "15px",
      position: "relative",
    },
    statsContainer: {
      padding: "6px 18px",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.75) 100%)",
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      borderRadius: "14px 14px 0 0",
      border: "1px solid rgba(46, 125, 50, 0.12)",
      borderBottom: "none",
      boxShadow: "0 -2px 12px rgba(46, 125, 50, 0.06)",
      width: "98%",
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      "@media (max-width: 768px)": {
        flexDirection: "column",
        gap: "6px",
        padding: "6px 12px",
      },
    },
    statsText: {
      fontSize: "0.78rem",
      color: t.text.secondary,
      fontWeight: "500",
      letterSpacing: "0.2px",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      background: "rgba(46, 125, 50, 0.04)",
      padding: "3px 10px",
      borderRadius: "14px",
      border: "1px solid rgba(46, 125, 50, 0.1)",
      transition: t.transition.fast,
      "&:hover": {
        background: "rgba(46, 125, 50, 0.08)",
        border: "1px solid rgba(46, 125, 50, 0.18)",
      },
    },
    statsValue: {
      fontSize: "0.88rem",
      fontWeight: "700",
      marginLeft: "1px",
    },
    statsDivider: {
      color: "rgba(46, 125, 50, 0.2)",
      fontSize: "1rem",
      fontWeight: "300",
      margin: "0 2px",
    },
    switchContainer: {
      display: "flex",
      alignItems: "center",
      background: "rgba(46, 125, 50, 0.04)",
      padding: "2px 10px 2px 12px",
      borderRadius: "14px",
      border: "1px solid rgba(46, 125, 50, 0.1)",
      transition: t.transition.fast,
      "&:hover": {
        background: "rgba(46, 125, 50, 0.08)",
        border: "1px solid rgba(46, 125, 50, 0.18)",
      },
      "& .form-switch": {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        paddingLeft: 0,
        minHeight: "auto",
        color: t.text.secondary,
        fontSize: "0.82rem",
        fontWeight: "500",
        letterSpacing: "0.3px",
      },
      "& .form-check-input": {
        width: "2.25rem",
        height: "1.15rem",
        backgroundColor: "rgba(0, 0, 0, 0.12)",
        borderColor: "rgba(0, 0, 0, 0.08)",
        cursor: "pointer",
        margin: 0,
        transition: t.transition.fast,
        "&:checked": {
          backgroundColor: "#2e7d32",
          borderColor: "#2e7d32",
        },
        "&:focus": {
          borderColor: "#2e7d32",
          boxShadow: "0 0 0 0.15rem rgba(46, 125, 50, 0.2)",
        },
      },
      "& .form-check-label": {
        fontSize: "0.82rem",
        fontWeight: "500",
        color: t.text.secondary,
        cursor: "pointer",
        marginBottom: 0,
      },
    },
    tabsWrapper: {
      margin: "0 auto",
      maxWidth: "98%",
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.6) 100%)",
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      borderRadius: "0 0 14px 14px",
      boxShadow:
        "0 4px 16px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
      border: "1px solid rgba(46, 125, 50, 0.1)",
      borderTop: "none",
      marginTop: "-1px",
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    offerCardsWrapper: {
      display: "flex",
      flexWrap: "wrap",
      gap: 20,
      justifyContent: "center",
      alignItems: "stretch",
      alignContent: "flex-start",
      marginTop: 0,
      padding: "20px 16px",
      flex: 1,
      color: t.text.primary,
      background: "rgba(255, 255, 255, 0.3)",
      backdropFilter: t.blur.light,
      WebkitBackdropFilter: t.blur.light,
      boxShadow: "none",
      borderRadius: "0 0 10px 10px",
    },
    drawerContainer: {
      background: "rgba(0,0,0,0.6)",
      "& .MuiBackdrop-root": {
        opacity: "0 !important",
        backgroundColor: "transparent",
        // backgroundColor: "white",
      },
    },
    drawer: {
      backdropFilter: "blur(2px)",
      backgroundColor: "transparent",
      minHeight: "95vh",
      zIndex: "1255 !important",
      width: "100%",
      height: "100%",
      // backgroundColor: appBarColors.drawerBg,
      // boxShadow: `0 3px 6px 0 ${appBarColors.appBarDropShadow}`,
      // left: "50%!important",
      // transform: "translateX(-50%)!important",
      // top: "3vh",
      // borderRadius: "20px",
    },
    buttons: {
      cursor: "pointer",
      borderRadius: "5px",
      background: "#50AB32",
      border: "none",
      height: "30px",
      color: "white",
    },

    searchBrandsContainer: {
      width: "90%",
      maxWidth: "1100px",
      display: "flex",
      margin: "24px auto",
      flexDirection: "column",
      justifyContent: "center",
    },
    searchPanel: {
      ...t.glassStyle.primary,
      borderRadius: t.radius.lg,
      boxShadow: t.shadow.lg,
      padding: "16px 20px 24px",
      display: "flex",
      flexDirection: "column",
    },
    searchPanelHeader: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      marginBottom: "12px",
      "& .backLabel": {
        fontSize: "0.95rem",
        fontWeight: 700,
        color: t.text.primary,
      },
    },

    brandCardsInSearchWrapper: {
      display: "flex",
      flexWrap: "wrap",
      margin: "20px 0 0",
      gap: "16px",
    },
    searchWrapper: {
      position: "relative",
      width: "100%",
      marginBottom: "16px",
      display: "flex",
      alignItems: "center",
    },
    searchIcon: {
      position: "absolute",
      left: 14,
      width: 24,
      height: 24,
      color: t.text.placeholder,
    },
    search: {
      height: "48px",
      fontSize: "0.95rem",
      width: "100%",
      paddingLeft: "48px",
      paddingRight: "16px",
      fontWeight: 400,
      borderRadius: t.radius.pill,
      border: t.border.base,
      backgroundColor: "rgba(84, 172, 52, 0.05)",
      boxShadow: "none",
      color: t.text.primary,
      outline: "none",
      transition: t.transition.fast,
      "&:focus": {
        backgroundColor: "#fff",
        border: `1px solid ${t.green.borderSelected}`,
      },
      "&::placeholder": {
        color: t.text.placeholder,
      },
    },
    searchTabsWrapper: {
      display: "flex",
      gap: "8px",
    },
    searchTabPill: {
      cursor: "pointer",
      border: t.border.base,
      background: "#fff",
      color: t.text.secondary,
      fontSize: "0.85rem",
      fontWeight: 600,
      padding: "8px 20px",
      borderRadius: t.radius.pill,
      transition: t.transition.fast,
      "&:hover": {
        background: t.green.bgHover,
      },
    },
    searchTabPillActive: {
      cursor: "pointer",
      border: `1px solid ${t.green.borderSelected}`,
      background: t.green.gradient,
      color: "#fff",
      fontSize: "0.85rem",
      fontWeight: 700,
      padding: "8px 20px",
      borderRadius: t.radius.pill,
      boxShadow: t.shadow.brand,
    },
    categoryWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
    },
    categoryText: {
      color: t.text.primary,
      fontSize: "0.82rem",
      fontWeight: 600,
      textAlign: "center",
    },
    offerDetailsContentWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      padding: 0,
    },
    locationDetailsContentWrapper: {
      margin: "5px 20px",
      display: " flex",
      flexDirection: " row",
      alignItems: " center",
      padding: " 70px 0",
      gap: " 20px",
      justifyContent: " center",
    },
    timerWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      padding: "8px 20px",
      "& span": {
        fontSize: 62,
      },
    },
    searchWraper: {
      margin: "1rem 4rem",
      padding: "5px",
      display: "block",
      width: "100%",
    },
    arrowButton: {
      background: "none",
      border: "none",
      fontSize: "2rem",
      cursor: "pointer",
      userSelect: "none",
      disabled: {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    },
    offerImage: {
      width: "60%",
      height: "70%",
      margin: "0 20px",
    },
    carouselContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
    },
    subText: {
      fontSize: "12px",
      color: "#ddd",
      width: "100%",
    },
    backArrow: {
      position: "absolute",
      top: 0,
      left: 0,
      fontSize: 12,
      color: "#fff!important",
      "& svg": {
        fontSize: "1rem",
      },
    },
    backArrows: {
      fontSize: 14,
    },
    logo_img: {
      float: "left",
      marginBottom: "10px",
      clear: "both",
    },
    searchLayer: {
      minWidth: "300px",
      width: "20%",
      alignItems: "left",
    },
    moreBrand: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: themeColors?.yashColor,
      position: "absolute",
      right: 0,
      bottom: 0,
    },
    moreMail: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      // marginLeft: 10,
      backgroundColor: themeColors?.yashColor,
    },
    noResult: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      padding: "36px 24px",
      borderRadius: "16px",
      background: t.glass.primary,
      backdropFilter: t.blur.light,
      border: t.border.base,
      boxShadow: t.shadow.sm,
      width: "100%",
    },
    noResultIcon: {
      width: "56px",
      height: "56px",
      borderRadius: "50%",
      background: t.green.bg,
      border: `1px solid ${t.green.border}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: t.green.solid,
    },
    noResultTitle: {
      fontSize: "1rem",
      fontWeight: "600",
      color: t.text.primary,
      lineHeight: 1.4,
      margin: 0,
    },
    noResultSub: {
      fontSize: "0.8rem",
      color: t.text.muted,
      margin: 0,
      lineHeight: 1.5,
    },
    relative: {
      clear: "both",
      position: "relative",
    },
    progress: {
      position: "absolute",
    },
    Grid: {
      maxWidth: "100%",
    },
    storeName: {
      fontSize: "0.7rem",
      textAlign: "center",
      background: "#fff",
      width: "100%",
      boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "0px 4px",
      fontWeight: "600",
    },
    mailNotification: {
      position: "relative",
      fontWeight: "500",
      fontSize: "18px",
      "& div": {
        background: "#fff",
        width: "12px",
        height: "12px",
        position: "absolute",
        right: 0,
        top: 0,
      },
    },
    menuBadge: {
      borderRadius: t.radius.circle,
      boxShadow: t.shadow.brand,
      minWidth: "18px",
      height: "18px",
      padding: "0 4px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      background: t.green.gradient,
      color: t.text.inverse,
      fontSize: "0.6rem",
      fontWeight: "700",
      letterSpacing: "0.15px",
    },
    switchBtn: {
      "& .btn": {
        fontSize: "0.8rem",
      },
    },
    // ── Offer Detail Modal (glassmorphism) ────────────────────────
    offerModalOverlay: {
      position: "fixed",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1300,
      background: "rgba(0, 0, 0, 0.55)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
    },
    offerModalCard: {
      position: "relative",
      width: "min(92vw, 1060px)",
      maxHeight: "82vh",
      overflow: "hidden",
      // Background image with frosted glass overlay
      background: `linear-gradient(135deg, rgba(255,255,255,0.72), rgba(255,255,255,0.68)), url(${mmBgGreen}) no-repeat center center / cover`,
      backdropFilter: "blur(80px) saturate(180%)",
      WebkitBackdropFilter: "blur(80px) saturate(180%)",
      borderRadius: t.radius.lg,
      border: "1px solid rgba(255, 255, 255, 0.35)",
      boxShadow:
        "0 8px 32px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.5)",
      padding: 0,
      zIndex: 1,
      marginTop: "48px",
      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        borderRadius: "inherit",
        background:
          "linear-gradient(120deg, rgba(255,255,255,0.35), rgba(255,255,255,0.08), transparent)",
        pointerEvents: "none",
        zIndex: 0,
      },
      "@media (max-width: 768px)": {
        width: "96vw",
        maxHeight: "85vh",
        marginTop: "52px",
      },
    },
    // Wider modal when rendering PDFs (50-50 split needs more room)
    offerModalCardPdf: {
      width: "min(96vw, 1440px)",
      maxHeight: "calc(100vh - 60px)",
      marginTop: "30px",
      "@media (max-width: 768px)": {
        width: "96vw",
      },
    },
    offerModalClose: {
      position: "absolute",
      top: "10px",
      right: "12px",
      zIndex: 1302,
      width: "40px",
      height: "40px",
      border: "none",
      borderRadius: t.radius.circle,
      background: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
      color: t.text.primary,
      cursor: "pointer",
      transition: t.transition.fast,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
      "& svg": { fontSize: "20px" },
      "&:hover": {
        background: "#fff",
        boxShadow: "0 4px 16px rgba(0,0,0,0.22)",
        transform: "scale(1.08)",
      },
      "@media (max-width: 768px)": {
        right: "8px",
        top: "8px",
      },
    },
    offerModalBack: {
      position: "absolute",
      top: "10px",
      left: "12px",
      zIndex: 1302,
      height: "40px",
      border: "none",
      borderRadius: t.radius.pill,
      background: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
      color: t.text.primary,
      fontSize: "13px",
      fontWeight: 600,
      padding: "0 16px 0 10px",
      cursor: "pointer",
      transition: t.transition.fast,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "2px",
      "& svg": { fontSize: "16px" },
      "&:hover": {
        background: "#fff",
        boxShadow: "0 4px 16px rgba(0,0,0,0.22)",
      },
      "@media (max-width: 768px)": {
        left: "8px",
        top: "8px",
      },
    },
    // Side-by-side layout for plain images
    offerModalHorizontal: {
      display: "flex",
      flexDirection: "row",
      minHeight: "380px",
      maxHeight: "82vh",
      overflowY: "auto",
      position: "relative",
      zIndex: 1,
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: t.green.scrollbar,
        borderRadius: "10px",
      },
      "@media (max-width: 768px)": {
        flexDirection: "column",
        maxHeight: "85vh",
      },
    },
    offerModalMediaLeft: {
      flex: "0 0 50%",
      maxWidth: "50%",
      display: "flex",
      alignItems: "stretch",
      justifyContent: "center",
      background:
        "linear-gradient(135deg, rgba(0,0,0,0.04) 0%, rgba(0,0,0,0.02) 100%)",
      borderRadius: `${t.radius.lg} 0 0 ${t.radius.lg}`,
      overflow: "hidden",
      padding: "0",
      borderRight: "1px solid rgba(0,0,0,0.06)",
      "& img": {
        maxWidth: "100%",
        maxHeight: "60vh",
        objectFit: "contain",
        borderRadius: t.radius.md,
        boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
      },
      "@media (max-width: 768px)": {
        flex: "unset",
        maxWidth: "100%",
        borderRadius: `${t.radius.lg} ${t.radius.lg} 0 0`,
        borderRight: "none",
        borderBottom: "1px solid rgba(0,0,0,0.06)",
        maxHeight: "40vh",
      },
    },
    offerModalContentRight: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      padding: "28px 24px",
      gap: "16px",
      overflow: "auto",
      background: "rgba(255,255,255,0.55)",
      backdropFilter: "blur(24px) saturate(160%)",
      WebkitBackdropFilter: "blur(24px) saturate(160%)",
    },
    // Vertical layout for video / pdf / html
    offerModalVertical: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      zIndex: 1,
      maxHeight: "82vh",
      overflowY: "auto",
      // single scrollbar for the whole vertical layout
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: t.green.scrollbar,
        borderRadius: "10px",
      },
      "@media (max-width: 768px)": {
        maxHeight: "85vh",
      },
    },
    offerModalMediaTop: {
      width: "100%",
      background:
        "linear-gradient(180deg, rgba(0,0,0,0.06) 0%, rgba(0,0,0,0.03) 100%)",
      borderRadius: `${t.radius.lg} ${t.radius.lg} 0 0`,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "340px",
      padding: "20px",
      position: "relative",
      borderBottom: "1px solid rgba(0,0,0,0.06)",
      "& img": {
        maxWidth: "100%",
        maxHeight: "50vh",
        objectFit: "contain",
        borderRadius: t.radius.md,
        boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
      },
      "& .App": {
        width: "100%",
        height: "100%",
      },
      "& video": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderRadius: t.radius.md,
      },
    },
    offerModalContentBelow: {
      padding: "24px 28px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      background: "rgba(255,255,255,0.55)",
      backdropFilter: "blur(24px) saturate(160%)",
      WebkitBackdropFilter: "blur(24px) saturate(160%)",
    },
    // Store header row inside content
    offerModalStoreRow: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
    },
    offerModalStoreInfo: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      flex: 1,
      minWidth: 0,
    },
    offerModalStoreBadges: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "8px",
    },
    offerModalStoreLogo: {
      width: "64px",
      height: "64px",
      borderRadius: t.radius.md,
      objectFit: "cover",
      border: "2px solid rgba(84, 172, 52, 0.2)",
      background: "#fff",
      boxShadow: t.shadow.xs,
      flexShrink: 0,
    },
    offerModalStoreName: {
      fontSize: "0.95rem",
      fontWeight: 700,
      color: t.text.primary,
      letterSpacing: "0.3px",
    },
    offerModalSubject: {
      fontSize: "1.15rem",
      fontWeight: 700,
      color: t.text.primary,
      lineHeight: 1.35,
      margin: 0,
    },
    offerModalMessage: {
      fontSize: "0.92rem",
      lineHeight: 1.65,
      color: t.text.secondary,
      margin: 0,
    },
    offerModalType: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "0.72rem",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      padding: "4px 12px",
      borderRadius: t.radius.pill,
      width: "fit-content",
    },
    offerModalTypePaid: {
      background:
        "linear-gradient(135deg, rgba(255, 152, 0, 0.15), rgba(255, 193, 7, 0.15))",
      color: "#e65100",
      border: "1px solid rgba(255, 152, 0, 0.25)",
    },
    offerModalTypeRegular: {
      background: "rgba(84, 172, 52, 0.1)",
      color: t.green.dark,
      border: `1px solid ${t.green.border}`,
    },
    // Floating redeem bar — positioned outside modal like back/close buttons
    offerModalRedeemBar: {
      position: "absolute",
      top: "12px",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1302,
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px 24px",
      borderRadius: t.radius.pill,
      background: "rgba(255, 255, 255, 0.92)",
      backdropFilter: "blur(16px)",
      WebkitBackdropFilter: "blur(16px)",
      boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
      whiteSpace: "nowrap",
      "@media (max-width: 768px)": {
        bottom: "8px",
        padding: "8px 16px",
        gap: "8px",
      },
    },
    // Timer / countdown for paid mails
    offerModalTimer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px 18px",
      borderRadius: t.radius.md,
      background:
        "linear-gradient(135deg, rgba(255, 152, 0, 0.08), rgba(255, 193, 7, 0.08))",
      border: "1px solid rgba(255, 152, 0, 0.18)",
    },
    offerModalTimerIcon: {
      fontSize: "22px",
      color: "#e65100",
      animation: "pulse 1.5s infinite",
    },
    offerModalTimerText: {
      fontSize: "0.85rem",
      fontWeight: 600,
      color: "#bf360c",
    },
    offerModalTimerCount: {
      fontSize: "1.3rem",
      fontWeight: 800,
      color: "#e65100",
      fontVariantNumeric: "tabular-nums",
      minWidth: "32px",
      textAlign: "center",
    },
    offerModalRedeemBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 16px",
      borderRadius: t.radius.pill,
      background: t.green.gradient,
      color: "#fff",
      fontSize: "0.78rem",
      fontWeight: 700,
      letterSpacing: "0.3px",
      boxShadow: t.shadow.brand,
      width: "fit-content",
    },
    offerModalBadgeRow: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "10px",
    },
    offerModalAmount: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "4px 12px",
      borderRadius: t.radius.pill,
      background: "rgba(84, 172, 52, 0.08)",
      border: `1px solid ${t.green.border}`,
      color: t.green.dark,
      fontSize: "0.82rem",
      fontWeight: 700,
      width: "fit-content",
    },
    offerModalNavLeft: {
      position: "absolute",
      left: "max(8px, calc(50% - min(46vw, 530px) - 56px))",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 1302,
      width: "44px",
      height: "44px",
      borderRadius: t.radius.circle,
      border: "none",
      background: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
      cursor: "pointer",
      transition: t.transition.fast,
      color: t.text.primary,
      "& svg": { fontSize: "20px", marginLeft: "3px" },
      "&:hover": {
        background: "#fff",
        boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        transform: "translateY(-50%) scale(1.08)",
      },
      "@media (max-width: 768px)": {
        left: "4px",
        width: "36px",
        height: "36px",
        "& svg": { fontSize: "16px", marginLeft: "2px" },
      },
    },
    offerModalNavRight: {
      position: "absolute",
      right: "max(8px, calc(50% - min(46vw, 530px) - 56px))",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 1302,
      width: "44px",
      height: "44px",
      borderRadius: t.radius.circle,
      border: "none",
      background: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
      cursor: "pointer",
      transition: t.transition.fast,
      color: t.text.primary,
      "& svg": { fontSize: "20px" },
      "&:hover": {
        background: "#fff",
        boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        transform: "translateY(-50%) scale(1.08)",
      },
      "@media (max-width: 768px)": {
        right: "4px",
        width: "36px",
        height: "36px",
        "& svg": { fontSize: "16px" },
      },
    },
    // PDF-mode overrides: push arrows outside the wider card
    offerModalNavLeftPdf: {
      left: "max(8px, calc(50% - min(48vw, 720px) - 56px))",
      "@media (max-width: 768px)": {
        left: "4px",
      },
    },
    offerModalNavRightPdf: {
      right: "max(8px, calc(50% - min(48vw, 720px) - 56px))",
      "@media (max-width: 768px)": {
        right: "4px",
      },
    },
    offerModalRedeemLoading: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px 18px",
      borderRadius: t.radius.md,
      background: "rgba(24, 144, 255, 0.06)",
      border: "1px solid rgba(24, 144, 255, 0.15)",
      color: "#1565c0",
      fontSize: "0.85rem",
      fontWeight: 500,
    },
  };
};
